import {postRequest} from '../../../../../middlewares/api/actions';
import {getImportCalculatedRules} from '../../../../../constants/urls';

export const FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_SHOW = 'FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_SHOW';
export const FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_HIDE = 'FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_HIDE';
export const FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_CHANGE = 'FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_CHANGE';
export const FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES = 'FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES';

export const showImportCalcRules = () => ({
  type: FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_SHOW
});

export const onHideImportCalcRules = () => ({
  type: FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_HIDE
});

export const changeFileMappingWizardCalcImport= fields => ({
  type: FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_CHANGE,
  fields
});

export const submitFileMappingWizardImportCalcRules = (file, tableName) => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);
  return postRequest(
      FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES,
      getImportCalculatedRules(tableName),
      fileFormData
  );
};